var map = {
	"./arbolabc.jpg": "e099",
	"./cokitos.jpg": "8dd4",
	"./geogebra.jpg": "91bb",
	"./idukay.jpg": "5bf6",
	"./phet.jpg": "2037",
	"./plataformas.psd": "8a8a",
	"./plazasesamo.jpg": "9c80f",
	"./runachay.jpg": "8c43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c72e";